var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErdefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 20,
    height: 20,
    rx: 10,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 20,
    height: 20,
    rx: 10,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1553 12.8843V14.6778C14.1553 14.7272 14.1152 14.7672 14.0658 14.7672H7.23831C7.15569 14.7672 7.11725 14.6648 7.17947 14.6104L11.0842 11.1989C11.289 11.02 11.2881 10.7013 11.0822 10.5236L7.18206 7.15715C7.11932 7.10299 7.15762 7 7.2405 7H14.0658C14.1152 7 14.1553 7.04004 14.1553 7.08944V8.41223",
    stroke: "#B9A2FF",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErdefault);
export default __webpack_public_path__ + "static/media/er.default.8351dfe2950fcfbe6daed374dc160678.svg";
export { ForwardRef as ReactComponent };